import { useState } from "react";
import "./WhatWeDo.css";
// import heroImg from "../../assets/service1.jpeg";
// import studioImg from "../../assets/interior.png";
// import p2Img from "../../assets/kids-study-bedroom.png";
// import p4Img from "../../assets/study-room.png";
// import p3Img from "../../assets/orchid-tv-room.png";
// import p6Img from "../../assets/dining-room-wide.png";

import heroImg from "../../assets/whatwedo/project-gallery-04.png";
import studioImg from "../../assets/whatwedo/kids-room.png";
import p2Img from "../../assets/kids-study-bedroom.png";
import p4Img from "../../assets/whatwedo/warm-living-01.jpeg";
import pmcMobileImg from "../../assets/whatwedo/warm-living-mobileonly.png";
import p3Img from "../../assets/whatwedo/renovation.png";
import p6Img from "../../assets/whatwedo/turnkey.png";

const SERVICES = [
  {
    n: "01",
    title: "Architecture",
    summary:
      "Ground-up buildings shaped by climate, context and structure.",
    description:
      "From site reading to construction administration, we design buildings whose form is inseparable from how they are made and where they stand.",
    image: heroImg,
  },
  {
    n: "02",
    title: "Interior Design",
    summary: "Interiors conceived at the same moment as the architecture.",
    description:
      "Spatial planning, joinery, material and light developed as one continuous body of work rather than a finishing layer.",
    image: studioImg,
  },
  // {
  //   n: "03",
  //   title: "3D Visualisation",
  //   summary:
  //     "Photographic studies used to make decisions, not to sell them.",
  //   description:
  //     "We model light and material early so proportion, tone and atmosphere can be judged before anything is built.",
  //   image: p2Img,
  // },
  // {
  //   n: "04",
  //   title: "Space Planning",
  //   summary: "Programme resolved to the last square foot.",
  //   description:
  //     "Adjacency, circulation and daylight tested across options until the plan works effortlessly in use.",
  //   image: p4Img,
  // },

  // {
  //   n: "03",
  //   title: "Project Managment ",
  //   summary: "Programme resolved to the last square foot.",
  //   description:
  //     "Adjacency, circulation and daylight tested across options until the plan works effortlessly in use.",
  //   image: p4Img,
  // },

{
  n: "03",
  title: "Project Management Consultancy (PMC)",
  summary: "Every detail managed, from plan to completion.",
  description:
    "From planning and contractor coordination to quality checks and timelines, every stage is managed to keep the project efficient, precise, and on track.",
  image: p4Img,
  mobileImage: pmcMobileImg,
},

  {
    n: "04",
    title: "Renovation",
    summary: "Careful additions to buildings that already have a life.",
    description:
      "We work with the existing structure — removing what obstructs, keeping what carries memory.",
    image: p3Img,
  },
  {
    n: "05",
    title: "Turnkey Design",
    summary: "Single-point delivery from first sketch to handover.",
    description:
      "Procurement, fabrication and site execution held by one team so the drawn intent survives the build.",
    image: p6Img,
  },
];

function ServicesAccordion() {
  const [active, setActive] = useState(0);
  const activeService = SERVICES[active];

  return (
    <div className="whatwedo-svc">
      <div className="whatwedo-svc-list">
        {SERVICES.map((service, i) => (
          <button
            key={service.n}
            type="button"
            className={"whatwedo-svc-row " + (active === i ? "whatwedo-svc-row-on" : "")}
            onMouseEnter={() => setActive(i)}
            onFocus={() => setActive(i)}
            onClick={() => setActive(i)}
            aria-expanded={active === i}
            data-cursor="link"
          >
            <img
              src={service.mobileImage || service.image}
              alt={`${service.title} — studio work`}
              className="whatwedo-mobile-visual"
              loading="lazy"
              decoding="async"
            />
            <span className="whatwedo-svc-num">{service.n}</span>
            <span>
              <h3>{service.title}</h3>
              <span className="whatwedo-svc-body">
                <span className="whatwedo-lede" style={{ display: "block" }}>
                  {service.description}
                </span>
              </span>
            </span>
            <span className="whatwedo-label">
              {service.summary.split(" ").slice(0, 2).join(" ")}
            </span>
          </button>
        ))}
      </div>

      <div className="whatwedo-svc-visual">
        {SERVICES.map((service, i) => (
          <img
            key={service.n}
            src={service.image}
            alt={`${service.title} — studio work`}
            className={active === i ? "whatwedo-svc-visual-on" : ""}
            loading="lazy"
            decoding="async"
          />
        ))}
        <span className="whatwedo-tag whatwedo-label whatwedo-label-fg">{activeService?.summary}</span>
      </div>
    </div>
  );
}

export default function WhatWeDo() {
  return (
    <section className="whatwedo-section whatwedo-band-dark" aria-labelledby="svc-h">
      <div className="whatwedo-wrap">
        <div className="whatwedo-head">
          <h2 id="svc-h" className="whatwedo-display whatwedo-d-md">
            What we do
          </h2>
          <p className="whatwedo-label">Fig. 03 — Capability</p>
        </div>
        <ServicesAccordion />
        {/* <div className="whatwedo-actions">
          <a className="whatwedo-cta whatwedo-cta-primary" href="/contact">
            Talk to a designer
          </a>
          <a className="whatwedo-cta whatwedo-cta-secondary" href="/contact">
            Get a free quote
          </a>
        </div> */}
      </div>
    </section>
  );
}
